function Blog() {
    return (
        <div>
            Blog
        </div>)
}

export default Blog;
